import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

/**
 * Checks if the "variable-charge-revamped-access-control" feature is enabled for this facility based on its attributes.
 */
export const useVariableChargeRevampFlag = (): {
  isVariableChargeRevampEnabled: boolean;
} => {
  const isVariableChargeRevampEnabled = useCbhFlag(
    CbhFeatureFlag.VARIABLE_CHARGE_REVAMPED_ACCESS_CONTROL,
    {
      defaultValue: false,
    }
  );

  return {
    isVariableChargeRevampEnabled,
  };
};
